import type { ComponentChildren, FunctionalComponent } from 'preact';

import { BubbleIcon } from '../__icon/bubble__icon.js';
import { cnBubble } from '../bubble.constants.js';

import './bubble__body.css';

import './_background-color/bubble__body_background-color.css';

export interface BubbleBodyProps {
    children: ComponentChildren;
    backgroundColor?: string;
}

export const BubbleBody: FunctionalComponent<BubbleBodyProps> = ({ children, backgroundColor }) => (
    <div className={cnBubble('body', { 'background-color': backgroundColor })}>
        <BubbleIcon />
        <p className={cnBubble('text')}>{children}</p>
    </div>
);
